import { defineRecipe } from "@chakra-ui/react";

export const selectRecipe = defineRecipe({
  base: {
    fontFamily: "body",
  },
  variants: {
    visual: {
      customSelect: {
        field: {
          bg: "darkBackground.100",
          color: "whiteAlfa.100",
          borderRadius: "30px",
          borderColor: "mainText.200",
          border: "1px solid",
        },
        icon: {},
      },
    },
  },
});
